import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { createPortal } from 'react-dom';


const Modal = ({ form, setIsModalOpen, isWide, fitContent, fullScreen }) => {
    const handleOverlayClick = (e) => {
        // Close modal when clicking on the overlay (outside the modal content)
        if (e.target === e.currentTarget) {
            setIsModalOpen(false);
        }
    };

    const handleContentClick = (e) => {
        // Prevent clicks on modal content from bubbling up to the overlay
        e.stopPropagation();
    };

    const contentClass = fullScreen
        ? 'modal-content-fullscreen'
        : isWide
            ? `model-content-wide${fitContent ? ' model-content-wide--fit' : ''}`
            : 'modal-content';

    return createPortal(
        <div className={`modal-overlay${fullScreen ? ' modal-overlay--fullscreen' : ''}`} onClick={handleOverlayClick}>
            <div 
                className={contentClass}
                onClick={handleContentClick}
            >
                <button 
                    className="modal-close-button"
                    onClick={() => setIsModalOpen(false)}
                >
                    <FontAwesomeIcon icon={faXmark} />
                </button>
                
                {form}
            </div>
        </div>,
        document.body
    );
};

export default Modal;